import { MAutocomplete, MTextField, ResponsiveFormContainer } from "@app/components";
import { useAnalysisTypes, useInstallation, useIsotopos } from "@services/servicesGenericsTables";
import React from "react";
import { useFormContext } from "react-hook-form";

const NivelesActividadCsnForm = () => {
  const { getValues } = useFormContext();
  const { installationList } = useInstallation();
  const { analysisTypeList } = useAnalysisTypes();
  const { isotoposList } = useIsotopos();

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MTextField
          name="grupo"
          label="Grupo"
          type="number"
        />
        <MAutocomplete
          key={JSON.stringify(getValues("isotopo"))}
          name="isotopo"
          options={isotoposList}
          label="Isótopo"
          getOptionLabel={(option) => `${option.codigo}`}
          validation={{ required: "El isótopo es requerido" }}
        />
        <MTextField
          name="actividadcsn"
          label="Actividad CSN"
        />
        <MTextField
          name="actividadcliente"
          label="Actividad Cliente"
        />
        <MAutocomplete
          key={JSON.stringify(getValues("instalacion"))}
          name="instalacion"
          options={installationList}
          label="Instalación"
          getOptionLabel={(option) => `${option.codigo} - ${option.descripcion}`}
        />
        <MAutocomplete
          key={JSON.stringify(getValues("analisis"))}
          name="analisis"
          options={analysisTypeList}
          label="Análisis"
          getOptionLabel={(option: any) => `${option.codigo} - ${option.descripcion}`}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default NivelesActividadCsnForm;
